/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { Sparkles } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { UrgencyPill } from './TriageMessage';

const SectionLabel = ({ children }) => (
  <span className="text-xs uppercase tracking-wide text-muted-foreground font-semibold">{children}</span>
);

/** Card di sintesi finale del triage AI (urgenza, sintesi, red flag, specialità). */
export const TriageFinalCard = ({ finalResult }) => (
  <Card className="p-4 border border-primary/30 bg-primary/5" data-testid="triage-final-card">
    <div className="flex items-center gap-2 mb-2">
      <Sparkles className="h-4 w-4 text-primary" />
      <h3 className="font-display font-semibold text-sm">Sintesi del triage</h3>
    </div>
    <div className="space-y-2 text-sm">
      <div>
        <SectionLabel>Urgenza</SectionLabel>
        <div className="mt-0.5"><UrgencyPill urgency={finalResult.urgency} testId="triage-final-urgency" /></div>
      </div>
      <div>
        <SectionLabel>Sintesi clinica</SectionLabel>
        <p className="mt-0.5 text-sm" data-testid="triage-final-summary">{finalResult.summary || 'Nessuna sintesi disponibile.'}</p>
      </div>
      {finalResult.red_flags?.length > 0 && (
        <div>
          <SectionLabel>Red flag</SectionLabel>
          <ul className="mt-0.5 text-sm list-disc pl-5 text-red-700" data-testid="triage-final-redflags">
            {finalResult.red_flags.map((rf, i) => <li key={`rf-${i}-${(rf || '').slice(0, 20)}`}>{rf}</li>)}
          </ul>
        </div>
      )}
      {finalResult.suggested_specialty && (
        <div>
          <SectionLabel>Specialità suggerita</SectionLabel>
          <p className="mt-0.5 text-sm font-semibold" data-testid="triage-final-specialty">{finalResult.suggested_specialty}</p>
        </div>
      )}
      <p className="text-[11px] text-muted-foreground italic pt-2 border-t border-border/60">
        {finalResult.disclaimer || 'Questo triage è solo di supporto e non sostituisce il parere medico.'}
      </p>
    </div>
  </Card>
);
